import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() { }

  emptyAll() {
    localStorage.clear();
  }

  set(key: string, data: any) {
    localStorage.setItem(key,  btoa(JSON.stringify(data)));
  }

  get(key:string)  {
    if(localStorage.getItem(key) != null) {
      return JSON.parse(atob(<string>localStorage.getItem(key)));
    }
    return null;
  }

  remove(key:string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}
